import AppProvider from "@app/providers/AppProvider";
import { preloadMainAppComponents } from "@components/LazyComponents";
import LazyErrorBoundary from "@components/LazyErrorBoundary";
import { GlobalToastManager } from "@components/toast/GlobalToastManager";
import "@emerald/style/_index.css";
import { RouteRenderer } from "@routes/RouteRenderer";
import { routesConfig } from "@routes/routes.config";
import { useEffect } from "react";
import { Routes } from "react-router";
import "./assets/css/App.css";

const AppRoutes = () => {
  // Preload critical components after initial render
  useEffect(() => {
    // Preload main app components after a short delay
    const timer = setTimeout(() => {
      preloadMainAppComponents();
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <LazyErrorBoundary>
      <Routes>{RouteRenderer({ routes: routesConfig })}</Routes>
    </LazyErrorBoundary>
  );
};

const App = () => {
  return (
    <AppProvider>
      <AppRoutes />
      <GlobalToastManager />
    </AppProvider>
  );
};

export default App;
